/**
 * returns the initial voice to be set if no voice has been set previously
 * @param {Array} voices - array of available voices in rsSpeechAPI
 * @param {string} userAgent - string containing the device information
 * @returns {string} - the voiceURI of the initial voice
 */
const getInitialVoice = (voices, userAgent) => {
  if (!voices.length) {
    console.warn('No TTS voices available');
    return;
  }

  let firstEnUSVoice;
  for (let voice of voices) {
    if (userAgent.isIOS || userAgent.isMac) {
      if (
        voice.name?.toLowerCase().trim() === 'karen' &&
        voice.lang?.toLowerCase().startsWith('en-')
      ) {
        // Find Karen for iOS
        return voice.voiceURI;
      } else if (
        voice.name?.toLowerCase().trim() === 'moira' &&
        voice.lang?.toLowerCase().startsWith('en-')
      ) {
        // Find Moira for iOS (fallback)
        return voice.voiceURI;
      }
    }

    // Find first en-US voice
    if (voice.lang?.toLowerCase() === 'en-us' && !firstEnUSVoice) {
      firstEnUSVoice = voice.voiceURI;
    }
  }

  // Return first en-US voice if Karen or Moira not found
  if (firstEnUSVoice) {
    return firstEnUSVoice;
  }

  // Find first voice
  return voices[0].voiceURI;
};

export default getInitialVoice;
